var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-header',[_c('b-row',{staticClass:"py-3",attrs:{"aling-v":"center"}},[_c('b-col',{attrs:{"cols":"7","lg":"6"}},[_c('nav',{staticClass:"d-none d-md-inline-block",attrs:{"aria-label":"breadcrumb"}})])],1)],1),_c('div',{staticClass:"mt--6"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }